export enum PolicyOriginTypes {
  Manual = 0,
  Downloads = 1,
  DataImport = 2,
  NowCertsWebServices = 3,
  DataImportManual = 4,
  EDocs = 5,
  Tasks = 6,
  SMS = 7,
  Automate = 8,
  Momentum = 10,
  NowCertsCarrierDownloadsService = 20,
  NotesOutlookPlugin = 21,
  ManualPush = 30
}

export const PolicyOriginTypesDescriptions: Record<PolicyOriginTypes, string> = {
  [PolicyOriginTypes.Manual]: 'Manual',
  [PolicyOriginTypes.Downloads]: 'Downloads',
  [PolicyOriginTypes.DataImport]: 'Data Import',
  [PolicyOriginTypes.NowCertsWebServices]: 'NowCerts Web Services',
  [PolicyOriginTypes.DataImportManual]: 'Data Import Manual',
  [PolicyOriginTypes.EDocs]: 'EDocs',
  [PolicyOriginTypes.Tasks]: 'Tasks',
  [PolicyOriginTypes.SMS]: 'SMS',
  [PolicyOriginTypes.Automate]: 'Automate',
  [PolicyOriginTypes.Momentum]: 'Momentum',
  [PolicyOriginTypes.NowCertsCarrierDownloadsService]: 'NowCerts Carrier Downloads Service',
  [PolicyOriginTypes.NotesOutlookPlugin]: 'Notes Outlook Plugin',
  [PolicyOriginTypes.ManualPush]: 'Manual-Push'
};

// helper function
export function getPolicyOriginTypesDescription(s: PolicyOriginTypes): string {
  return PolicyOriginTypesDescriptions[s];
}